<template>
  <Loader :show="loading" v-if="loading" />
  <div v-else>
    <CategoryTop :breadcrumbs-parent-routes="['trainings', onlineTrainingLink()]"
      :breadcrumbs-route-name="training.title[storedLocale]" class="mb-3" :showBreadcrumbs="true" contentClass=""
      mainClass="training-container" />
    <MDBRow>
      <MDBCol xl="5" cols="12" class="mb-1">
        <div class="lightboxContainer">
          <div class="lightbox" @click="showLightBox = true"></div>
          <iframe v-if="training && training.video" class="vimeo" frameborder="0" :src="training.video[storedLocale]"
            allow="fullscreen" title="" data-ready="true" tabindex="-1"></iframe>
        </div>
      </MDBCol>
      <MDBCol xl="7" cols="12" class="mb-1">
        <div class="textBox h-auto textBox__training">
          <h5 v-if="training" v-html="training.title[storedLocale]"></h5>
          <div v-if="training" v-html="training.short_description[storedLocale]"></div>

          <div v-if="trainingDone" class="text-success fw-bold mt-2">
            {{ $t("trainings.single.done") }}
          </div>
        </div>
      </MDBCol>
    </MDBRow>

    <Lightbox v-if="showLightBox" :video="training.video[storedLocale]"
      @close="(showValue) => (showLightBox = showValue)" />
  </div>
</template>

<script setup>
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import Lightbox from "./../Form/Inputs/Lightbox.vue";
import CategoryTop from "@/components/General/CategoryTop/index.vue";
import Loader from "@/components/General/Loader/index";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { setOnlineTrainingLink } from "@/composables/useProfileFieldCheck";

const store = useStore();
const route = useRoute();
const { tenantConfig } = useTenantConfig();
const { onlineTrainingLink } = setOnlineTrainingLink(tenantConfig);

let showLightBox = ref(false);
const isWholesaler = ref(false);

const user = computed(() => store.getters.getMe);
const training = computed(() => store.getters.getTraining);
const storedLocale = computed(() => store.getters.getCurrentLocale);
const trainingDone = computed(() => store.getters.getTrainingResult);
const loading = computed(() => {
  const currentTraining = training.value;
  const trainingId = currentTraining?.id ?? currentTraining?.hashId;

  return !currentTraining?.title || String(trainingId) !== String(route.params.id);
});

watch(user, async (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name == "wholesaler")) {
    isWholesaler.value = true;
  }
});
</script>

<style scoped lang="scss">
@import "../../../styles/_variables.scss";

.vimeo {
  width: 100%;
  height: 300px;
}

.breadcrumbContainer {
  padding: 28px 0;
}
</style>
